// @ts-ignore
window.$ = window.jQuery = require("jquery");

import "jquery-ui/ui/core";
import "jquery-ui/ui/widgets/sortable";
import "jquery-ui/ui/widgets/selectable";
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui/ui/i18n/datepicker-fr";
import "jquery-ui/ui/disable-selection";
import "jquery-ui/ui/effect.js";

import "jquery-jsonview/dist/jquery.jsonview.js";

import "../../../../vendor/yiisoft/yii2/assets/yii";
import "../../../../vendor/yiisoft/yii2/assets/yii.gridView";
import "../../../../vendor/yiisoft/yii2/assets/yii.validation";
import "../../../../vendor/yiisoft/yii2/assets/yii.activeForm";

import "yii2-pjax";
import "bootstrap/dist/js/bootstrap";
import "admin-lte/dist/js/adminlte";
import "bootstrap-daterangepicker/daterangepicker.js";

import "select2";

import {Maps} from "./maps";
import {Dialog} from "./dialog";
import {initFuzzySelect} from "./fuzzy-select";

import "./main-search";

const moment = require("moment");
moment.locale("fr");

(<any>window).Maps = Maps;
(<any>window).initFuzzySelect = initFuzzySelect;

declare const yii: {
  allowAction(e: JQuery);
  confirm(
    message: string,
    ok: CallableFunction,
    cancel?: CallableFunction,
    e?: JQuery
  );
  handleAction(element: object);
};

$(() => {
  Dialog.init();
  initFuzzySelect();

  // add ajax new
  $("[data-ajaxnew]").each(function () {
    if (this.dataset.ajaxnew) {
      const label = this;
      const action = $("<a>")
      .text("")
      .attr("href", this.dataset.ajaxnew)
      .addClass("js-dialog ajax-new fa fa-plus-square")
      .attr("data-ajaxnew", "#" + this.id);
      $(label).after(action);
    }
  });
})

// @ts-ignore
$(".daterange").daterangepicker(
  {
    autoUpdateInput: false,
    "showCustomRangeLabel": false,
    "alwaysShowCalendars": true,
    ranges: {
      "Aujourd'hui": [moment(), moment()],
      "Hier": [moment().subtract(1, "days"), moment().subtract(1, "days")],
      "7 derniers jours": [moment().subtract(6, "days"), moment()],
      "30 derniers jours": [moment().subtract(29, "days"), moment()],
      "Ce mois": [moment().startOf("month"), moment().endOf("month")],
      "Mois dernier": [
        moment()
        .subtract(1, "month")
        .startOf("month"),
        moment()
        .subtract(1, "month")
        .endOf("month")
      ],
      "Tout": [null, null],
    },
    locale: {
      cancelLabel: 'Afficher toutes les données',
      format: "DD/MM/YYYY"
    }
  },
  function (start, end) {
    const url = new URL(document.location.toString());
    let period = start.format("YYYY-MM-DD") + "@" + end.format("YYYY-MM-DD");
    if (!start.isValid()) {
      period = "none";
    }
    url.searchParams.set("period", period);
    document.location = url.toString();
  }
).on('cancel.daterangepicker', function(ev, picker) {
  //do something, like clearing an input
  const url = new URL(document.location.toString());
  let period = "none";
  url.searchParams.set("period", period);
  document.location = url.toString();
}).on('apply.daterangepicker', function (ev, a, b) {
  const url = new URL(document.location.toString());
  console.log("a", a.startDate.isValid())
  let period =  a.startDate.format("YYYY-MM-DD") + "@" + a.endDate.format("YYYY-MM-DD");
  if (!a.startDate.isValid()) {
    period = "none";
  }
  url.searchParams.set("period", period);
  document.location = url.toString();
})
